import React, { useContext } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';

import { DataContext } from '../../../stores/covering-table-store';
import CustomTimeInput from '../shared/CustomTimeInput';
import { CustomDatepickerHeader } from '../shared/CustomDatepickerHeader';

import sv from 'date-fns/locale/sv';
registerLocale('sv', sv);

const WeekPickers = () => {
    const {
        store: { startWeek, endWeek },
        dispatch,
    } = useContext(DataContext);

    const updateStartWeek = (week) => {
        let newEndWeek = week > endWeek ? week : endWeek;

        dispatch({
            type: 'WEEK_UPDATE',
            startWeek: week,
            endWeek: newEndWeek,
        });
    };

    return (
        <div className='d-flex align-content-top'>
            <div className='d-flex justify-content-between align-items-center mt-1 filter-week-picker'>
                <span className='week-date-picker'>
                    <DatePicker
                        renderCustomHeader={(props) => CustomDatepickerHeader(props)}
                        selected={startWeek}
                        onChange={(week) => updateStartWeek(week)}
                        dateFormat='ww'
                        customInput={<CustomTimeInput />}
                        showDayMonthPicker
                        maxDate={null}
                        locale='sv'
                        showWeekNumbers
                    />
                </span>
                <span className='oi oi-arrow-right padding-left-15px padding-right-15px'></span>
                <span className='week-date-picker'>
                    <DatePicker
                        renderCustomHeader={(props) => CustomDatepickerHeader(props)}
                        selected={endWeek}
                        onChange={(week) =>
                            dispatch({
                                type: 'WEEK_UPDATE',
                                startWeek: startWeek,
                                endWeek: week,
                            })
                        }
                        dateFormat='ww'
                        customInput={<CustomTimeInput />}
                        showDayMonthPicker
                        minDate={startWeek}
                        locale='sv'
                        popperPlacement='bottom-end'
                        showWeekNumbers
                    />
                </span>
            </div>
        </div>
    );
};

export default WeekPickers;
